import { render, staticRenderFns } from "./knowledge-panel.vue?vue&type=template&id=2086115c&scoped=true"
import script from "./knowledge-panel.ts?vue&type=script&lang=ts&external"
export * from "./knowledge-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./knowledge-panel.scss?vue&type=style&index=0&id=2086115c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2086115c",
  null
  
)

export default component.exports